import { PropsWithChildren } from "react";
import { useFeatureFlags } from "contexts/FeatureFlagContext";
import { NotFound } from "pages/NotFound";

type ManuscriptRouteGuardProps = PropsWithChildren<{
  allowTeaser?: boolean;
}>;

export function ManuscriptRouteGuard({
  children,
  allowTeaser = false,
}: ManuscriptRouteGuardProps) {
  const { features } = useFeatureFlags();

  if (!features.uploadManuscript) {
    if (allowTeaser && features.uploadManuscriptTeaser) {
      return children;
    }
    return <NotFound />;
  }

  return children;
}
